export default __webpack_public_path__ + "static/media/icons8-syringe.11c0e261.svg";